<template>
  <div>
    <!-- 
      BANNER: Wenn organisation.verified = false || organisation.setupStatus === 'pending' || organisation.setupStatus === ''
     -->
    <!-- <v-banner single-line color="grey darken-3" @click:icon="alert" dark>
      <v-icon slot="icon" color="error" size="24"> mdi-alert </v-icon>
      Die Einrichtung deiner Organisation ist noch nicht abgeschlossen.
      <template v-slot:actions>
        <v-btn color="error" depressed>
          Einrichtung fortsetzen
          <v-icon right small>mdi-chevron-right</v-icon>
        </v-btn>
      </template>
    </v-banner> -->
    <section v-if="loading">
      <layout-loading v-if="loading" :overlay="true"></layout-loading>
    </section>
    <section
      v-else-if="!loading && organizationInMaintenance && !actualUserIsSupport"
    >
      <v-container class="fill-height mt-16">
        <v-row align="top" justify="center">
          <v-col cols="12" sm="12" md="8">
            <div class="text-center">
              <v-avatar color="warning" rounded size="70" class="mb-4">
                <v-icon x-large color="white"> mdi-wrench-clock</v-icon>
              </v-avatar>
              <h5 class="text-h5 font-weight-medium">Wartungsmodus aktiv</h5>
              <p class="subtitle-1">
                Diese Organisation befindet sich im Wartungsmodus. Es können
                momentan keine Änderungen vorgenommen werden.
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section v-else-if="!loading && actualUserIsSupport">
      <v-card flat tile>
        <v-toolbar outlined sticky fixed dense>
          <v-chip
            v-if="organizationInMaintenance"
            small
            color="warning"
            class="font-weight-medium"
            ><v-icon left small> mdi-wrench-clock</v-icon>Wartung</v-chip
          >
          <v-chip
            v-else-if="!organizationInMaintenance"
            small
            color="success"
            class="font-weight-medium"
            ><v-icon left small> mdi-wrench-check</v-icon>Bereit</v-chip
          >
          <v-btn
            depressed
            small
            class="mx-2"
            :loading="maintenanceModeChangeLoading"
            @click="changeMaintenanceMode"
            ><v-icon left small>mdi-swap-horizontal</v-icon>Status
            wechseln</v-btn
          >

          <v-divider vertical class="mx-2"></v-divider>

          <v-btn
            depressed
            small
            :color="supportViewAsNormalUser ? 'primary' : 'default'"
            @click="toggleSupportView"
            class="mx-2"
          >
            <v-icon left small>{{
              supportViewAsNormalUser ? "mdi-eye" : "mdi-eye-off"
            }}</v-icon>
            {{ supportViewAsNormalUser ? "Als Benutzer" : "Als Support" }}
          </v-btn>

          <v-spacer></v-spacer>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn depressed small v-bind="attrs" v-on="on"
                ><v-icon small>mdi-dots-horizontal</v-icon></v-btn
              >
            </template>
            <v-list nav>
              <span>
                <!-- organizationId -->
                <v-list-item
                  link
                  @click="
                    copyToClipboard(
                      JSON.stringify($route.params.organizationId, undefined, 4)
                    )
                  "
                >
                  <v-list-item-icon>
                    <v-icon>mdi-office-building</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="mb-2">
                      <code>organizationId</code>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <code>{{ $route.params.organizationId }}</code>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      @click="
                        copyToClipboard(
                          JSON.stringify(
                            $route.params.organizationId,
                            undefined,
                            4
                          )
                        )
                      "
                      icon
                      ><v-icon small>mdi-content-copy</v-icon></v-btn
                    >
                  </v-list-item-action>
                </v-list-item>
                <!-- requiredPermissions -->
                <!-- uid -->
                <v-list-item
                  link
                  @click="
                    copyToClipboard(JSON.stringify(currentUserId, undefined, 4))
                  "
                >
                  <v-list-item-icon>
                    <v-icon>mdi-badge-account-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="mb-2">
                      <code>uid</code>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <code>{{ currentUserId }}</code>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      @click="
                        copyToClipboard(
                          JSON.stringify(currentUserId, undefined, 4)
                        )
                      "
                      icon
                      ><v-icon small>mdi-content-copy</v-icon></v-btn
                    >
                  </v-list-item-action>
                </v-list-item>

                <!-- Reset Support View Preference -->
                <v-divider></v-divider>
                <v-list-item link @click="resetSupportViewPreference">
                  <v-list-item-icon>
                    <v-icon>mdi-refresh</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="mb-2">
                      Support-Ansicht zurücksetzen
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Lokale Einstellungen löschen
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <!-- existingPermissions -->
              </span>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-card>
      <router-view />
    </section>
    <section v-else-if="!loading && !userHasPermission">
      <v-container class="fill-height mt-16">
        <v-row align="top" justify="center">
          <v-col cols="12" sm="12" md="8">
            <div class="text-center">
              <v-avatar color="error" rounded size="70" class="mb-4">
                <v-icon x-large color="white"> mdi-alert-octagon</v-icon>
              </v-avatar>
              <h5 class="text-h5 font-weight-medium">Zugriff verweigert</h5>
              <p class="subtitle-1">
                Du hast nicht die erforderlichen Berechtigungen für diese
                Aktion.
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <router-view v-else />
  </div>
</template>

<script>
import LayoutLoading from "@/components/_system/helpers/Loading.vue";
import { auth, functions } from "@/firebase";
import { ORGANISATION } from "@/store/modules.js";
import { GET_MEMBERSHIP, GET_ORGANIZATION } from "@/store/action-types.js";

export default {
  name: "organization-detail",
  components: {
    LayoutLoading,
  },
  data() {
    return {
      currentUserId: auth.currentUser ? auth.currentUser.uid : null,
      maintenanceModeChangeLoading: false,
    };
  },
  computed: {
    loading() {
      return this.$store.state.organization.loading;
    },
    actualUserIsSupport() {
      return this.$store.getters["organization/checkIfActualSupport"];
    },
    userIsSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    supportViewAsNormalUser() {
      return this.$store.state.organization.supportViewAsNormalUser;
    },
    permissions() {
      return (
        this.$store.state.organization.membership.access.permissions
          .allPermissionsIds || []
      );
    },
    requiredPermissions() {
      return this.$route.matched
        .filter((route) => route.meta.permissionID)
        .map((route) => route.meta.permissionID);
    },
    userHasPermission() {
      const requiredPermissions = this.$route.matched
        .filter((route) => route.meta.permissionID)
        .map((route) => route.meta.permissionID);
      // console.log(requiredPermissions);
      // const permissionsOfUser =
      //   this.$store.state.organization.membership.access.allPermissionsIds ||
      //   [];

      // return requiredPermissions.every((permission) =>
      //   permissionsOfUser.includes(permission)
      // );
      return requiredPermissions.every((permission) =>
        this.$store.getters["organization/checkPermissionByID"](permission)
      );
    },
    organizationInMaintenance() {
      return this.$store.state.organization.activeOrganization.config
        .inMaintenance;
    },
  },
  created() {
    // Restore support view preference from localStorage
    const savedPreference = localStorage.getItem("supportViewAsNormalUser");
    if (savedPreference !== null) {
      this.$store.commit(
        "organization/SET_SUPPORT_VIEW_AS_NORMAL_USER",
        savedPreference === "true"
      );
    }
    this.initialize();
  },
  methods: {
    async initialize() {
      const organizationId = this.$route.params.organizationId;
      const userId = auth.currentUser.uid;

      // Using Promise.all to run both dispatches in parallel
      await Promise.all([
        this.$store.dispatch(`${ORGANISATION}${GET_MEMBERSHIP}`, {
          organizationId,
          userId,
        }),
        this.$store.dispatch(`${ORGANISATION}${GET_ORGANIZATION}`, {
          organizationId,
        }),
      ]);
      this.$store.commit(`${ORGANISATION}SET_LOADING`, false);
    },
    toggleSupportView() {
      const newValue = !this.supportViewAsNormalUser;
      this.$store.commit(
        "organization/SET_SUPPORT_VIEW_AS_NORMAL_USER",
        newValue
      );
      // Store the preference in localStorage so it persists across page reloads
      localStorage.setItem("supportViewAsNormalUser", newValue.toString());
    },
    resetSupportViewPreference() {
      // Remove from localStorage
      localStorage.removeItem("supportViewAsNormalUser");
      // Reset store to default (support view)
      this.$store.commit("organization/SET_SUPPORT_VIEW_AS_NORMAL_USER", false);
      // Optional: Show confirmation
      alert("Support-Ansicht Einstellungen wurden zurückgesetzt.");
    },
    changeMaintenanceMode() {
      this.maintenanceModeChangeLoading = true;
      const callFunction = functions.httpsCallable(
        "support-changeOrganizationMaintenanceStatus"
      );
      callFunction({
        organizationId: this.$route.params.organizationId,
        newMaintenanceStatus: !this.organizationInMaintenance,
      })
        .then((result) => {
          console.log(result.data);
          if (result.data.success) {
            this.maintenanceModeChangeLoading = false;
          } else {
            alert("Fehler");
            console.error(result);
            this.maintenanceModeChangeLoading = false;
          }
        })
        .catch((err) => {
          // handle error
          console.error(err);
          alert(err.message);
          this.maintenanceModeChangeLoading = false;
        });
    },
    // Copies a string to the clipboard. Must be called from within an event handler such as click.
    // May return false if it failed, but this is not always
    // possible. Browser support for Chrome 43+, Firefox 42+, Edge and IE 10+.
    // No Safari support, as of (Nov. 2015). Returns false.
    // IE: The clipboard feature may be disabled by an adminstrator. By default a prompt is
    // shown the first time the clipboard is used (per session).
    copyToClipboard(text) {
      if (window.clipboardData && window.clipboardData.setData) {
        // IE specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Fehler beim Kopieren in Zwischenablage.", ex);
          this.snackbarText = "Fehler beim Kopieren in Zwischenablage!";
          this.snackbar = true;
          return false;
        } finally {
          document.body.removeChild(textarea);
          this.snackbarText = "Erfolgreich in Zwischenablage kopiert!";
          this.snackbar = true;
        }
      }
    },
  },
  // destroyed() {
  //   this.$store.dispatch(`${ORGANISATION}${UNSUBSCRIBE_MEMBERSHIP}`, {
  //     organizationId: this.$route.params.organizationId,
  //     userID: auth.currentUser.uid,
  //   });
  //   this.$store.dispatch(`${ORGANISATION}${UNSUBSCRIBE_ORGANISATION}`, {
  //     organizationId: this.$route.params.organizationId,
  //     userID: auth.currentUser.uid,
  //   });
  // },
};
</script>
